import { useModalHook } from '@/components/commons/modals/useModalHook';
import { toggleSaveModalRecoil, unknownReceiverRecoil } from '@/recoil/atoms/modalRecoil';
import { instance } from '@/shared/lib/clientAxios';
import { useQueryClient } from '@tanstack/react-query';
import { Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { IoClose } from 'react-icons/io5';
import { useRecoilState, useSetRecoilState } from 'recoil';
import * as S from './ToggleSaveModal.style';
import { useGroupList } from '@/components/hooks/customs/newAddressBook/useGroupList';

const ToggleSaveModal = () => {
  const queryClient = useQueryClient();
  const setToggleSaveModalS = useSetRecoilState(toggleSaveModalRecoil);
  const [unknownReceiverS, setUnknownReceiverS] = useRecoilState(unknownReceiverRecoil);
  /* 주소록 리스트 데이터 get api 요청의 params */
  const modalHooks = useModalHook();

  const [selectedGroup, setSelectedGroup] = useState();

  const groupListQueryData: any = queryClient.getQueryData(['groupList2']);

  const hook = useGroupList();

  const onClickClose = () => {
    setUnknownReceiverS([]);
    setToggleSaveModalS(false);
  };

  const onClickSave = async () => {
    const formatData = unknownReceiverS.map((item) => ({
      groupSeqNo: selectedGroup,
      buddyNm: '(이름없음)',
      keyCommNo: item,
      birthday: '',
      marriageDay: '',
    }));

    try {
      await instance.post('/contacts/large-buddy', formatData);
      await setUnknownReceiverS([]);
      await setToggleSaveModalS(false);

      modalHooks.customSuccessModal(
        () => {
          hook.refetch();
          queryClient.refetchQueries(['/groupBuddyList']);
        },
        '성공',
        '저장 되었습니다.',
        true,
      );
    } catch (error) {
      await setUnknownReceiverS([]);
      await setToggleSaveModalS(false);
      modalHooks.warningModal('실패', '주소록 저장에 실패 했습니다.', true);
    }
  };

  const options = groupListQueryData.groupList.map((group: any) => ({
    value: group.groupSeqNo,
    label: group.groupNm,
  }));

  useEffect(() => {
    if (groupListQueryData?.groupList?.length > 0) {
      setSelectedGroup(groupListQueryData.groupList[0].groupSeqNo);
    }
  }, [groupListQueryData?.groupList]);

  return (
    <S.Background>
      <S.Container>
        <S.Header>
          <div>등록되지 않은 수신번호 저장하기</div>
          <S.CloseButton onClick={onClickClose}>
            <IoClose />
          </S.CloseButton>
        </S.Header>

        <S.Main>
          <S.length>총 {unknownReceiverS.length} 명 </S.length>
          <S.Contents>{`그룹을 선택해 주세요.('이름없음' 으로 저장 됩니다.)`}</S.Contents>

          <Select
            value={selectedGroup}
            placeholder="그룹을 선택해 주세요"
            onChange={setSelectedGroup}
            options={options}
            style={{ width: '80%', height: '4rem', fontSize: '4rem' }} // 선택된 값의 스타일
            dropdownStyle={{ fontSize: '4rem' }} // 드롭다운 내부 폰트 크기
          />
        </S.Main>

        <S.bottom>
          <S.ConfirmButton onClick={onClickSave}>저장</S.ConfirmButton>
        </S.bottom>
      </S.Container>
    </S.Background>
  );
};

export default ToggleSaveModal;
